import { Fragment, useEffect, useState } from 'react';
import { api, errorText, formatDateTime } from '../api';
import { Badge, Card, Empty, Loading, Notice } from '../components/ui';

interface Mail {
  id: string;
  an: string[];
  betreff: string;
  text: string;
  angelegt_am: string;
  versendet_am: string | null;
  versuche: number;
  letzter_fehler: string | null;
}

export function EskalationPage() {
  const [empfaenger, setEmpfaenger] = useState('');
  const [mailVersand, setMailVersand] = useState(true);
  const [mails, setMails] = useState<Mail[] | null>(null);
  const [offen, setOffen] = useState<string | null>(null);
  const [meldung, setMeldung] = useState<{ art: 'error' | 'success'; text: string } | null>(null);

  useEffect(() => {
    void api<{ empfaenger: string[]; mailVersand: boolean }>('/api/einstellungen/eskalation').then((r) => {
      setEmpfaenger(r.empfaenger.join('\n'));
      setMailVersand(r.mailVersand);
    });
    void api<{ mails: Mail[] }>('/api/einstellungen/mailausgang').then((r) => setMails(r.mails));
  }, []);

  async function speichern() {
    try {
      const liste = empfaenger.split(/[\n,;]+/).map((e) => e.trim()).filter(Boolean);
      const r = await api<{ empfaenger: string[] }>('/api/einstellungen/eskalation', { method: 'PUT', body: { empfaenger: liste } });
      setEmpfaenger(r.empfaenger.join('\n'));
      setMeldung({ art: 'success', text: 'Empfänger gespeichert.' });
    } catch (e) {
      setMeldung({ art: 'error', text: errorText(e) });
    }
  }

  return (
    <>
      <div className="kopf">
        <h1>Eskalation &amp; Mails</h1>
      </div>
      {meldung && <Notice kind={meldung.art}>{meldung.text}</Notice>}
      {!mailVersand && (
        <Notice kind="warn">
          Der Mailversand ist noch nicht eingerichtet (SMTP fehlt auf dem Server). Eskalationsmails werden gesammelt und unten angezeigt, aber
          nicht verschickt. Die Eskalationsempfänger sehen überfällige Tickets trotzdem auf ihrer Startseite.
        </Notice>
      )}
      <div className="stack">
        <Card title="Eskalationsempfänger" actions={<button className="primary" onClick={() => void speichern()}>Speichern</button>}>
          <p className="muted" style={{ marginTop: 0 }}>
            Eine Adresse pro Zeile. Diese Personen bekommen eine Sammelmail, sobald Tickets über die Eskalationszeit hinaus liegen, und sehen auf
            „Mein Tag" alle eskalierten Tickets des Hauses.
          </p>
          <textarea value={empfaenger} onChange={(e) => setEmpfaenger(e.target.value)} style={{ minHeight: 100 }} className="mono" />
        </Card>

        <Card title="Mailausgang" padded={false}>
          {!mails ? (
            <Loading />
          ) : mails.length === 0 ? (
            <Empty>Noch keine Mails.</Empty>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Erstellt</th>
                  <th>Betreff</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {mails.map((m) => (
                  <Fragment key={m.id}>
                    <tr className="klickbar" onClick={() => setOffen(offen === m.id ? null : m.id)}>
                      <td className="small">{formatDateTime(m.angelegt_am)}</td>
                      <td>
                        {m.betreff}
                        <div className="small muted">{m.an.join(', ')}</div>
                      </td>
                      <td>
                        {m.versendet_am ? (
                          <Badge kind="ok">versendet</Badge>
                        ) : m.letzter_fehler ? (
                          <Badge kind="bad">Fehler ({m.versuche}×)</Badge>
                        ) : (
                          <Badge kind="warn">wartet</Badge>
                        )}
                      </td>
                    </tr>
                    {offen === m.id && (
                      <tr>
                        <td colSpan={3}>
                          <pre className="mono" style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{m.text}</pre>
                          {m.letzter_fehler && <div className="small" style={{ color: 'var(--bad)' }}>{m.letzter_fehler}</div>}
                        </td>
                      </tr>
                    )}
                  </Fragment>
                ))}
              </tbody>
            </table>
          )}
        </Card>
      </div>
    </>
  );
}
